<template>
  <section id="premium" class="premium-area pt-100 pb-70">
    <div class="container">

      <!-- Header -->
      <div class="one-section-title text-center">
        <span class="sub-title">{{ $t('premium.subTitle') }}</span>
        <h2>{{ $t('premium.title') }}</h2>
        <p class="lead">
          {{ $t('premium.desc') }}
        </p>
      </div>

      <!-- Cards -->
      <div class="row g-4">
        <div class="col-md-6 col-lg-4" v-for="(item, i) in services" :key="i">
          <div class="premium-card">
            <i :class="item.icon"></i>
            <h4>{{ $t(item.title) }}</h4>
            <p>{{ $t(item.text) }}</p>
          </div>
        </div>
      </div>

      <!-- CTA -->
      <div class="cta-wrap">
        <a href="https://wa.me/34634061655" target="_blank" class="whatsapp-btn">
          <i class="bx bxl-whatsapp"></i>
          {{ $t('premium.cta') }}
        </a>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: "PremiumServices",
  data() {
    return {
      services: [
        {
          icon: "bx bx-dish",
          title: "premium.services.s1.title",
          text: "premium.services.s1.text"
        },
        {
          icon: "bx bx-calendar-event",
          title: "premium.services.s2.title",
          text: "premium.services.s2.text"
        },
        {
          icon: "bx bx-wine",
          title: "premium.services.s3.title",
          text: "premium.services.s3.text"
        },
        {
          icon: "bx bx-building-house",
          title: "premium.services.s4.title",
          text: "premium.services.s4.text"
        },
        {
          icon: "bx bx-group",
          title: "premium.services.s5.title",
          text: "premium.services.s5.text"
        },
        {
          icon: "bx bx-star",
          title: "premium.services.s6.title",
          text: "premium.services.s6.text"
        }
      ]
    }
  }
}
</script>

<style scoped>
:root {
  --main-color: #ff8a00;
}

/* ===============================
   SECCIÓN GENERAL
   =============================== */
.premium-area {
  background: #ffffff;
  color: #222;
  position: relative;
}

/* ===============================
   HEADER
   =============================== */
.one-section-title .sub-title {
  color: var(--main-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 700;
  margin-bottom: 8px;
}

.one-section-title h2 {
  font-weight: 800;
  color: #111;
  margin-bottom: 10px;
}

.lead {
  max-width: 820px;
  margin: 0 auto 30px;
  color: #666;
}

/* ===============================
   CARDS
   =============================== */
.premium-card {
  background: linear-gradient(145deg, #ffffff, #fff7f0);
  border: 1px solid rgba(255, 138, 0, 0.15);
  border-radius: 14px;
  padding: 26px;
  height: 100%;
  text-align: left;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.04);
  position: relative;
  overflow: hidden;
}

.premium-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 4px;
  background: linear-gradient(to bottom, #7c1900, #ff4800);
}

.premium-card:hover {
  transform: translateY(-6px);
  border-color: #ff4800;
  box-shadow: 0 15px 35px rgba(255, 138, 0, 0.18);
}

.premium-card i {
  font-size: 34px;
  color: #7c1900;
  margin-bottom: 12px;
  background: rgba(255, 138, 0, 0.1);
  padding: 10px;
  border-radius: 10px;
}

.premium-card h4 {
  font-weight: 700;
  margin-bottom: 8px;
  color: #111;
}

.premium-card p {
  color: #666;
  margin: 0;
}

/* ===============================
   CTA
   =============================== */
.cta-wrap {
  display: flex;
  gap: 14px;
  justify-content: center;
  margin: 40px 0 10px;
  flex-wrap: wrap;
}

.whatsapp-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 26px;
  border-radius: 12px;
  background: linear-gradient(135deg, #25D366, #1ebe5d);
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  box-shadow: 0 10px 25px rgba(37, 211, 102, 0.35);
  text-decoration: none;
  transition: all 0.25s ease;
}

.whatsapp-btn i {
  font-size: 20px;
}

.whatsapp-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(37, 211, 102, 0.5);
}

/* ===============================
   RESPONSIVE
   =============================== */
@media (max-width: 767px) {
  .premium-card {
    text-align: center;
  }
}
</style>